import { withInstall } from '@/utils'
import TabsConversion from './src/index.vue'
export default withInstall(TabsConversion)
